module.exports = __webpack_public_path__ + "img/ff8b89e.jpg";